export default __webpack_public_path__ + "static/media/ChetanBafna.440c3cd0.png";